import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import './ConsultancyofficerLayout.css';
import {CHeader }from '../../Header/CHeader';
import { CProfile } from '../../consultancyofficer/CProfile';
import ConsultancyofficerMenu from '../../consultancyofficer/consultancyofficermenu/ConsultancyofficerMenu'
import { ConOffActivities} from '../../consultancyofficer/ConOffActivities';
//import {ConOfflogin}  from '../../consultancyofficer/ConOfflogin';
import {CLoginoff} from '../../consultancyofficer/CLoginoff';



interface ConsultancyofficerLayout {

  children?: ReactNode;
  // Define children as a ReactNode
}
const ConsultancyofficerLayout: React.FC<ConsultancyofficerLayout> = ({ children }) => {


  return (
    <div className="finace-layout-container">
      <CHeader/>
      <div >
        <ConsultancyofficerMenu />
        
          <Routes>
              <Route path="/cprofile" element={<CProfile />} />
              <Route path="/coactivities" element={<ConOffActivities/>} />
              <Route path="/cologin" element={<CLoginoff />} />


          </Routes>
      </div>
      { children }
      {/* <Footer /> */}
    </div>  );
};

export default ConsultancyofficerLayout;
